import { render, staticRenderFns } from "./ComparisonReportTableHead.vue?vue&type=template&id=344108b6&scoped=true&"
import script from "./ComparisonReportTableHead.vue?vue&type=script&lang=js&"
export * from "./ComparisonReportTableHead.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonReportTableHead.vue?vue&type=style&index=0&id=344108b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344108b6",
  null
  
)

export default component.exports